import { useRef } from 'react'
import { useTheme } from 'next-themes'
import { useDeliveryAppContext } from '@/context/deliveryApp/DeliveryAppContext'
import { useRipple } from '@/hooks/useRipple'

const RouteButton = () => {
  const ref = useRef(null)
  useRipple(ref, 'rgb(169, 174, 179, 0.3)')
  const { driver } = useDeliveryAppContext()
  const optimapUrl = driver?.optimap_url

  return (
    <div>
      <div
        ref={ref}
        className={`${
          optimapUrl ? 'hover:cursor-pointer' : ''
        } relative w-12 h-12 p-3 overflow-hidden rounded-full`}
      >
        {optimapUrl ? (
          <a href={optimapUrl} target="_blank" rel="noreferrer">
            <RouteIcon />
          </a>
        ) : (
          <RouteIcon />
        )}
      </div>
    </div>
  )
}
export default RouteButton

const RouteIcon = () => {
  const { resolvedTheme } = useTheme()
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512 512"
      fill={resolvedTheme === 'dark' ? '#282d32' : '#e5e9ec'}
    >
      <path d="M416 256H328C305.9 256 288 273.9 288 296C288 318.1 305.9 336 328 336H424C472.6 336 512 375.4 512 424C512 472.6 472.6 512 424 512H139.6C148.3 502.1 158.9 489.4 169.6 475.2C172.3 471.6 175 467.8 177.8 464H424C446.1 464 464 446.1 464 424C464 401.9 446.1 384 424 384H328C279.4 384 240 344.6 240 296C240 247.4 279.4 208 328 208H374.1C348.3 174.9 320 130.7 320 96C320 42.98 362.1 0 416 0C469 0 512 42.98 512 96C512 135.2 476 186.4 448.1 220.2C430.4 241.6 416 256 416 256zM454.1 126.5C461.7 111.3 464 101.1 464 96C464 69.49 442.5 48 416 48C389.5 48 368 69.49 368 96C368 101.1 370.3 111.3 377.9 126.5C385.2 141 395.4 156.5 406.4 171.2C409.6 175.5 412.8 179.6 416 183.6C419.2 179.6 422.4 175.5 425.6 171.2C436.6 156.5 446.8 141 454.1 126.5V126.5zM128.1 476.2C124.8 480.2 121.6 483.1 118.6 487.4C118.3 487.8 117.1 488.1 117.7 488.4C114 492.7 110.6 496.4 107.7 499.6C107.6 499.8 107.4 499.9 107.3 500.1C100.4 507.6 96 512 96 512C96 512 81.57 497.6 63.9 476.2C35.99 442.4 0 391.2 0 352C0 298.1 42.98 256 96 256C149 256 192 298.1 192 352C192 386.7 163.7 430.9 137.9 464C134.6 468.3 131.3 472.3 128.1 476.2L128.1 476.2zM134.1 382.5C141.7 367.3 144 357.1 144 352C144 325.5 122.5 304 96 304C69.49 304 48 325.5 48 352C48 357.1 50.29 367.3 57.93 382.5C65.18 397 75.38 412.5 86.4 427.2C89.61 431.5 92.84 435.6 96 439.6C99.16 435.6 102.4 431.5 105.6 427.2C116.6 412.5 126.8 397 134.1 382.5V382.5z" />
    </svg>
  )
}
